import AXIOS from '@/axios-instance';

export default {

  retrieveUser(userId){
    return AXIOS.get("/user/"+userId);
  },
  checkRoleForCurrentUser(role) {
    return AXIOS.get("/role/" + role);
  },
  addUser(user) {
    return AXIOS.post("/user/add", user);
  },
  retrieveUsers() {
    return AXIOS.get("/user");
  },
  retrieveRolesForUser() {
    return AXIOS.get("/user/roles");
  },
  editUser(user){
    return AXIOS.put("/user", user);
  },
  getClientsForUser(){
    return AXIOS.get("/user/clients");
  },
  changeCurrentClientForUser(clientId){
    return AXIOS.post("/user/client", clientId, {
      headers: { "Content-Type": "application/json" }
    });
  }
}